import { OrderModel } from '@epicuro-next/data/order-book';
import {
  IDynamicBindableValue,
  IDynamicBindableValueCombination,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { Order } from 'graphql-api/gql-api-interfaces';
import { ShipToAddressType } from '../../../types/ship-to-address';

type HttpOrdersProviderType = {
  filters: [
    {
      fieldId: 'DeliveryDate_requested';
      values: [string, string];
    },
  ];
  search: '';
};
export const httpOrdersProvider: IDynamicBindableValue = {
  provider: 'HttpOrderService',
  property: {
    values: [
      {
        provider: 'id:root',
        property: 'fromDate',
      },
      {
        provider: 'id:root',
        property: 'toDate',
      },
    ],
    transform: function ([fromDate, toDate]: string[]): HttpOrdersProviderType {
      return {
        filters: [
          {
            fieldId: 'DeliveryDate_requested',
            values: [fromDate, toDate],
          },
        ],
        search: '',
      };
    }.toString(),
  },
  filter: function (value: unknown): boolean {
    return value !== undefined;
  }.toString(),
};

export const shipToOptionsProvider: IDynamicBindableValueCombination = {
  values: [
    httpOrdersProvider,
    {
      provider: 'GlobalStoreProviderService',
      property: {
        path: 'accounts.activeAccount.shipToAddresses',
      },
      filter: function (value: unknown): boolean {
        return value !== undefined;
      }.toString(),
    },
  ],
  transform: function ([ordersData, shipToAddressess]: [
    OrderModel,
    ShipToAddressType[],
  ]) {
    function calcProductCount(address: string): number {
      return ordersData.orders.reduce((prev: number, curr: Order) => {
        if (
          curr?.address?.split('(')?.pop()?.includes(address) &&
          curr?.confirmedQuantity
        ) {
          return prev + curr.confirmedQuantity;
        }

        return prev;
      }, 0);
    }

    const shipToAddressFilters =
      shipToAddressess?.map((item: ShipToAddressType) => ({
        count: calcProductCount(item.realAddressId ?? ''),
        displayName: item.name,
        realAddressId: item.realAddressId,
      })) ?? [];

    const selectOptions = [];

    for (const shipToAddressFilter of shipToAddressFilters) {
      const count = shipToAddressFilter?.count ?? 0;

      const shopName = shipToAddressFilter.displayName;
      const displayName = `${shopName} (${shipToAddressFilter.realAddressId})`;

      const filterValue = {
        name: shipToAddressFilter.realAddressId ?? '',
        displayName,
        count,
      };

      selectOptions.push(filterValue);
    }

    return selectOptions;
  }.toString(),
};

export const StoresSelect = {
  id: 'stores-filter-select',
  contentTypeId: 'dynamic-elements-filter-select',
  data: {
    options: shipToOptionsProvider,
  },
  inputs: {
    filterItem: {
      provider: 'self',
      property: 'options',
      startWith: {
        values: [],
      },
      transform: function (options: any) {
        return {
          isSingle: true,
          values: options,
        };
      }.toString(),
    },
    activeValues: {
      provider: 'id:root',
      property: 'shipToAddressId',
      startWith: [],
      transform: function ($event: any) {
        return $event ?? [];
      }.toString(),
    },
    fieldDisplayName: 'Choose Stores',
    selectedValuesAsLabel: true,
    dropdownButtonClass: 'btn-light',
  },
};
